import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { Get_Api } from '../ApiUrls';
import WhatsAppButton from '../Components/WhatsAppButton';

function Termsandcondition() {
    const [termsandcondition, setTermsandcondition] = useState("");



    const fetchTermsandcondition = async () => {
        try {
            const response = await Get_Api('api/admin/GetTermsandcondition');;
            if (response.data) {
                setTermsandcondition(response.data.Termsandcondition);
            }
        } catch (error) {
            console.error("Error fetching Terms And Condition", error);
        }
    };

    useEffect(() => {
        fetchTermsandcondition();
    }, []);

    return (
        <>
            <Navbar />
            <div className="ContactUs-header">
                <h1>Terms And Condition</h1>
                <p>
                    Home / <span className="active">Terms And Condition</span>
                </p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '20px' }}>
                <div
                    dangerouslySetInnerHTML={{ __html: termsandcondition }}
                    style={{
                        color: 'black',
                        fontSize: '15px',
                        lineHeight: '2.0',
                        maxWidth: '800px',
                        width: '100%',
                    }}
                />
            </div>
            <WhatsAppButton/>
            <Footer />
        </>
    )
}

export default Termsandcondition